<template>
  <div id="login" class="h-100 container d-flex flex-wrap justify-content-center">
    <div class="card align-self-center" style="max-width: 360px;">
      <div class="card-header bg-white">
        <img src="../assets/images/logo-cee.png" class="card-img-top img-fluid" alt="Cabecera CEE">
      </div>
      <div class="card-body" v-loading="loadingLogin">
        <form v-if="isWebpSupported" class="form-signin" v-on:submit.prevent="login">
          <div class="form-group">
            <label for="inputEmail">Usuario</label>
            <input
              type="email"
              class="form-control"
              id="inputEmail"
              v-model="loginDetails.username"
              aria-describedby="emailHelp"
              placeholder="Usuario"
            >
          </div>
          <div class="form-group">
            <label for="inputPassword">Contraseña</label>
            <input
              type="password"
              class="form-control"
              id="inputPassword"
              v-model="loginDetails.password"
              placeholder="Contraseña"
            >
          </div>
          <button
            class="btn btn-dark btn-block mt-4"
            type="submit"
            :disabled="submitDisabled"
          >Acceder</button>
        </form>
        <template class v-else>
          <el-alert
            type="warning"
            :closable="false"
            title="Necesitas Chrome, Firefox u Opera para acceder"
          ></el-alert>
          <ul class="list-group mt-2">
            <li class="list-group-item bg-light border-0">
              <i class="fab fa-chrome" aria-hidden="true"></i>
              <a
                class="ml-2 text-primary"
                target="_blank"
                href="https://www.google.com/chrome/"
              >Descargar Chrome</a>
            </li>
            <li class="list-group-item bg-light border-0">
              <i class="fab fa-firefox" aria-hidden="true"></i>
              <a
                class="ml-2 text-primary"
                target="_blank"
                href="https://www.mozilla.org/es-ES/firefox/"
              >Descargar Firefox</a>
            </li>
            <li class="list-group-item bg-light border-0">
              <i class="fab fa-opera" aria-hidden="true"></i>
              <a
                class="ml-2 text-primary"
                target="_blank"
                href="https://www.opera.com/es"
              >Descargar Opera</a>
            </li>
          </ul>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { APIENDPOINT, CLIENTID, CLIENTSECRET } from "@/backend";

var qs = require("qs");

export default {
  name: "Login",
  data() {
    return {
      loadingLogin: false,
      clientId: CLIENTID,
      clientSecret: CLIENTSECRET,
      loginDetails: {
        grant_type: "password",
        username: "",
        password: ""
      }
    };
  },

  created: function() {},

  methods: {
    login() {
      this.loadingLogin = true;
      axios({
        method: "post",
        baseURL: APIENDPOINT,
        url: "/api/admin/login",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        data: qs.stringify(this.loginDetails),
        auth: {
          username: this.clientId,
          password: this.clientSecret
        }
      })
        .then(response => this.loginSuccessful(response))
        .catch(() => this.loginFailed());
    },

    loginSuccessful(response) {
      // console.group("loginSuccessful");
      // console.log(response);
      // console.groupEnd();
      if (!response.data.access_token) {
        // console.log("no hay token");
        this.loginFailed();
        return;
      }
      this.loadingLogin = false;
      localStorage.setItem("token", JSON.stringify(response.data));
      this.$store.dispatch("login");
      // this.$store.dispatch('token', JSON.stringify(response.data))
      // this.$router.replace(this.$route.query.redirect || '/home')
      this.$router.push("/home");
    },

    loginFailed() {
      this.loadingLogin = false;
      // this.message = err.error_description
      this.message = "Acceso denegado";
      this.$message({
        showClose: true,
        message: this.message,
        type: "warning"
      });
      this.$store.dispatch("logout");
      delete localStorage.token;
    }
  },

  computed: {
    isWebpSupported() {
      // console.info(window.navigator)
      return (
        window.navigator.userAgent.includes("Chrome") ||
        window.navigator.userAgent.includes("Firefox") ||
        window.navigator.userAgent.includes("CriOS")
      );
    },

    submitDisabled() {
      return (
        this.apiendpoint === "" ||
        this.loginDetails.email === "" ||
        this.loginDetails.password === ""
      );
    }
  }
};
</script>
